module.exports = __webpack_public_path__ + "static/media/18_r_stena_86.67_9.81.1b97b953.png";